import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function Shop2Icon(props: IconProps) {
    return <Icon {...props} iconKey={"shop_2"}/>
}
